module.exports = __webpack_public_path__ + "img/collection-diamondJewelryColliers@2x.8e23b08.jpg";